import React from "react";
import "./Cookies.css";

const Cookies = () => {
  return (
    <div className="cookie-container">
      <div className="cookie-content">
        <h1>Cookie Policy</h1>

        <p>
          This Cookies Policy sets out the basis on which we,
          <strong> LogicSphere Technologies Pvt Ltd </strong>
          (“LogicSphere”, “we”, “us”, or “our”), use cookies and similar
          technologies on or in relation to our website,
          <strong> www.logicspheretechnologies.com </strong> and any of our
          related digital platforms (collectively, our “Website”).
        </p>

        <p>
          At <strong>LogicSphere Technologies Pvt Ltd</strong>, we use cookies
          and similar technologies to enhance your browsing experience,
          improve website functionality, analyze traffic, and continuously
          improve our IT services and digital solutions.
        </p>

        <h2>1. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help websites function efficiently and provide
          information about user interactions.
        </p>

        <h2>2. Why We Use Cookies</h2>
        <ul>
          <li>To ensure secure and smooth website operation</li>
          <li>To understand how visitors use our website</li>
          <li>To improve website performance and functionality</li>
          <li>To remember user preferences</li>
          <li>To support marketing and communication efforts</li>
        </ul>

        <h2>3. Types of Cookies We Use</h2>

        <h3>Essential Cookies</h3>
        <p>
          These cookies are necessary for the website to function properly.
          They enable core features such as security, network management, and accessibility.
        </p>

        <h3>Analytics Cookies</h3>
        <p>
          These cookies help us analyze website traffic and user behavior so we
          can improve performance and user experience.
        </p>

        <h3>Functional Cookies</h3>
        <p>
          These cookies allow the website to remember choices you make and
          provide enhanced, more personalized features.
        </p>

        <h3>Marketing Cookies</h3>
        <p>
          These cookies may be used to deliver relevant advertisements and
          measure the effectiveness of our marketing campaigns.
        </p>

        <h2>4. Third-Party Cookies</h2>
        <p>
          Some cookies may be placed by third-party services such as analytics
          providers or social media platforms. We do not control these cookies
          and recommend reviewing their respective privacy policies.
        </p>

        <h2>5. Managing Cookies</h2>
        <p>
          You can control and manage cookies through your browser settings.
          Please note that disabling certain cookies may affect website
          functionality and performance.
        </p>

        <h2>6. Updates to This Policy</h2>
        <p>
          We may update this Cookie Policy from time to time to reflect changes
          in legal requirements or our services. Any updates will be posted on
          this page with a revised effective date.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions regarding this Cookie Policy, you may contact us at:
        </p>
        <p>
          <strong>Email:</strong> support@logicspheretechnologies.com
        </p>
      </div>
    </div>
  );
};

export default Cookies;
